// extracted by mini-css-extract-plugin
export var SolutionsBanner = "index-module--SolutionsBanner--FW6Zd";
export var hideRight = "index-module--hideRight--JMZ3t";